import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { LoadingOverlay } from '@mantine/core'
import { SearchTree } from '@ow/comps'
import { useAppEx } from '@vt/hooks'
import { listToTree } from '@ow/utils'

const Tree = memo(({ data, value, checkable, setSelectedIds, levelType }) => {
  const treeData = useMemo(() => {
    let originData = data
    if (!checkable && value?.length) {
      const parentValues = []
      data.forEach((item) => {
        if (item.parentIds && value.includes(item.objectId)) {
          parentValues.push(...item.parentIds)
        }
      })

      parentValues.push(...value)

      originData = originData.filter((item) =>
        parentValues.includes(item.objectId)
      )
    }
    return listToTree(
      originData
        .filter((item) => !item.isDisableNode)
        .map((item) => ({ ...item, id: item.objectId }))
    )
  }, [data, checkable, value])

  const onCheck = useCallback(
    (_, node) => {
      const nodeList =
        levelType === 'isLastLevel'
          ? node.checkedNodes.filter((nodes) => {
              return nodes.extData.isLastLevel
            })
          : node.checkedNodes
      const keys = nodeList.map((nodes) => nodes.key)

      if (setSelectedIds) {
        setSelectedIds(keys)
      }
    },
    [levelType]
  )

  const setExtData = useCallback(
    (item) => ({
      isLastLevel: item.children.length === 0,
      label: item.parentsName.join('-'),
    }),
    []
  )
  return (
    <SearchTree
      data={treeData}
      ckey="objectId"
      label="title"
      height="auto"
      checkStrictly={levelType !== 'isLastLevel'}
      checkable={checkable}
      checkedKeys={value}
      selectable={false}
      onCheck={onCheck}
      setExtData={setExtData}
    />
  )
})

const StandardTree = ({ value, checkable, setSelectedIds, levelType }) => {
  const { getDitto } = useAppEx()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const ditto = getDitto('standard')

  useEffect(() => {
    const loadData = async () => {
      setLoading(true)
      const res = await ditto.fetchAll()
      setLoading(false)
      setData(res)
    }

    loadData(0)
  }, [])

  return (
    <div>
      <LoadingOverlay visible={loading} />
      <Tree
        data={data}
        checkable={checkable}
        value={value}
        setSelectedIds={setSelectedIds}
        levelType={levelType}
      />
    </div>
  )
}

export default memo(StandardTree)
